const LangMyTransactions = {
	"myTransactions._title": ["MY TRANSACTIONS", "GIAO DỊCH CỦA TÔI"],
	"myTransactions.header._transactions": ["TRANSACTIONS", "GIAO DỊCH"],
	"myTransactions.header._amount": ["AMOUNT", "SỐ TIỀN"],
	"myTransactions.header._starEarned": ["STAR EARNED", "ĐIỂM NGÔI SAO"],
	"myTransactions.header._datetime": ["DATE TIME", "THỜI GIAN"],
	"myTransactions.header._outlet": ["STORE", "CỬA HÀNG"],
	"myTransactions.body._noAvailableRecord": [
		"There are no transactions at the moment",
		"Tài khoản của bạn hiện chưa có giao dịch",
	],
	"myTransactions.type.SALES": ["In Store Purchase", "In Store Purchase"],
	"myTransactions.type.PLUS ADJUSTMENT": ["In Store Reload", "In Store Reload"],
	"myTransactions.type.CUSTOMER CARE": ["Customer Care Center", "Customer Care Center"],
	"myTransactions.type.FUNDS TRANSFER": ["Funds Transfer", "Funds Transfer"],
	"myTransactions.type.MINUS ADJUSTMENT": ["MINUS ADJUSTMENT", "vi_MINUS ADJUSTMENT"],
	"myTransactions.type.POINTS REDEMPTION": [
		"POINTS REDEMPTION",
		"vi_POINTS REDEMPTION",
	],
	"myTransactions.type.REFUND SALES ITEMS": [
		"REFUND SALES ITEMS",
		"vi_REFUND SALES ITEMS",
	],
	"myTransactions.type.POINTS REWARD FOR ITEM": [
		"POINTS REWARD FOR ITEM",
		"vi_POINTS REWARD FOR ITEM",
	],
	"myTransactions.type.ITEM REDEMPTION": ["ITEM REDEMPTION", "vi_ITEM REDEMPTION"],
	"myTransactions.type.VOUCHER REDEMPTION": ["Reward Redemption", "Reward Redemption"],
	"myTransactions._details": ["Details", "Chi tiết"],
}

export default LangMyTransactions
